import * as ng from 'angular';
import { UISelectService } from '../../../../services/ui-select.service';
import { ArchiSmallServices } from '../../../../services/archismall.service';
import { Object } from 'es6-shim';
import { diff } from 'deep-object-diff';
import { ITimestamps } from '../../../../commons/interfaces/timestamps';


class MarcheTemporaliController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      marcheTemporali: (Omit<ITimestamps, 'date'> & {date: string})[]
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService
  ) {
    // $scope.entries = Object.entries;
    $scope.pageHeader = 'Marche Temporali';
    $scope.pageSubHeader = '';
    $rootScope.formsubmitted = false;
    $scope.filtroScadenza = [];
    let filter = [] as (Omit<ITimestamps, 'date'> & {date: Date})[];

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.filterStamps = () => {
      $scope.marcheTemporali = filter
        .filter((item) =>
          item.date.getTime() > ($scope.filtroScadenza[0] ? $scope.filtroScadenza[0].getTime() : 0) &&
          item.date.getTime() < ($scope.filtroScadenza[1] ? $scope.filtroScadenza[1].getTime() : Infinity))
        .sort(({date: a}, {date: b}) => b.getTime() - a.getTime())
        .map(item => ({number: item.number, date: item.date.toLocaleDateString()}));
    };

    $scope.getTimestamps = () => {
      ArchiSmallServices.getRemainingTimestamps()
        .then((response) => {
          // $scope.marcheTemporali = JSON.parse(JSON.stringify(response)) as ITimestamps[];
          filter = (JSON.parse(JSON.stringify(response)) as ITimestamps[]).map(item => ({number: item.number, date: new Date(item.date)}));
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getTimestamps();

  }
}

export const MarcheTemporaliComponent: ng.IComponentOptions = {
  template: require('./marche_temporali.html'),
  controller: MarcheTemporaliController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/marche_temporali/marche_temporali.ts